import { render } from "./TextMessage.vue?vue&type=template&id=1cc50c80&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=js"
export * from "./TextMessage.vue?vue&type=script&lang=js"

import "./TextMessage.vue?vue&type=style&index=0&id=1cc50c80&scoped=true&lang=scss"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc50c80"]])

export default __exports__